export default {
  file: {
    title1: '公司謄本',
    title2:'银行存折',
    title3:'银行存折翻开首页',
    btn: '上传',
    label0: '法人证件',
    label01: '',
    label0Error: '法人证件不能为空',
    label1: '公司营业执照副本（发行三个月以内）',
    labe1Error: '公司营业执照副本不能为空',
    label2: '银行存折（封面）',
    label2Note: '(若使用网上银行截图，须为能同时确认银行名、分行号/分行名、账号、户名的材料。)',
    labe2Error: '银行存折（封面）不能为空',
    label3: '银行存折（翻开首页内页）',
    labe3Error: '银行存折（翻开首页内页）不能为空',
    label4: '营业执照等',
    labe4Error: '营业执照等不能为空',
    label5: '二手营业许可',
    label6: '風俗営業許可証',
    label7: '旅行業登録票（標識）',
    label8: '旅館業許可証、許可証あるいは証明書',
    label9: '自動車整備業認証書あるいは指定書',
    label10: 'その他',
    tip: '文件大小：2MB以内',
    fileTip:'文件格式：JPEG、PNG、JPG、 PDF。文件尺寸限制：10MB内',
    aboutIndustryTip: '下記業種に該当するお客様は該当許可証のご用意をお願いいたします。',
    aboutIndustrytrailTip: '上記以外にもお申込内容により、別途許認可証が必要になる場合がございます、ご了承ください。',


    errorTypeTip:'只能上传 PNG, JPG 或 PDF 文件!',
    request1: '我已阅读并确认同意「GlobePay決済加盟店規約」。',
    request2: '我已确认以上申请内容，并且无任何异议，同意上述内容变更并申请。',
    confirmation: {
      title: '确认请求',
      content: '关于信息变更・增加支付品牌，通过向我司GlobePay支付服务申请・各品牌审核通过后，加盟店合约即告成立。',
      instruction: '请再次确认以下条款及协议，如同意请在复选框内打勾。',
    },
     file: '勾选并同意《GlobePay支付服务商户条款》',
         file2: '',
    submitApplication: '提出申请',
    submit: '提交'
  }
}
